import "../../modal.scss";
import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import { Datatable } from "../articulosTable/Datatable";
import { ArticulosState } from "../../../context/articulos/ArticulosState";

Modal.setAppElement("#root"); // Necesario para accesibilidad

const ArticulosModal = ({ handleChange,handleDescChange,descSelected,onSelect,tipoprecio,
  findNoCombo=false ,   
  findStock=false ,   
  disableSelection,
  enableSelectionFinder,
  enableCheckboxSelection,
  enableSelectionClick=true,
  enablePagination=true,
  tipovista="completo",
  }) => {
  let name="Articulo";
  const [searchIdItem, setSearchIdItem] = useState("");
  const [searchDescItem, setSearchDescItem] = useState(`Buscar ${name}`);
  const searchInputRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Sincronizar descSelected inicial con el estado
  useEffect(() => {
    if (descSelected && searchDescItem !== descSelected) {
      setSearchIdItem(0);
      setSearchDescItem(descSelected);
    } else if (!descSelected && searchDescItem !== "") {
      setSearchDescItem("");
    }
  }, [descSelected]);

  const handleRowClick = (selectedId, selectedDesc,selectedCod,selectedCos,selectedMay,selectedMin) => {
    setSearchIdItem(selectedId);
    handleChange(selectedId);
    setSearchDescItem(selectedDesc);
    onSelect&&onSelect(selectedId,selectedCod, selectedDesc,selectedCos,selectedMay,selectedMin);
    setIsModalOpen(false); // Cierra el modal automáticamente
  };

  const handleClear = () => {
    setSearchIdItem(null);
    setSearchDescItem("");
    handleChange(null);
    handleDescChange("");
    if (searchInputRef.current) {
      searchInputRef.current.value = `Buscar ${name}`;
    }
  };

  return (
    <>
      <div className="inputWrapper">
        <input
          type="text"
          value={searchDescItem || "Buscar " + name}
          readOnly
          ref={searchInputRef}
        />
        {!searchIdItem && !searchDescItem && (
          <button
            className="SearchButton"
            onClick={(e) => {
              e.preventDefault();
              setIsModalOpen(true);
            }}
          >
            🔍
          </button>
        )}
        {(searchIdItem || searchDescItem) && (
          <button
            className="clearButton"
            onClick={(e) => {
              e.preventDefault();
              handleClear();
            }}
          >
            ❌
          </button>
        )}
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Seleccionar"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="data-grid-container">
          <div
            className="datatable"
            style={{
              height: "100%",
              maxHeight: "calc(80vh - 60px)",
              overflowY: "auto",
            }}
          >
            <ArticulosState>
              <Datatable
                onSelect={handleRowClick}
                onClose={() => setIsModalOpen(false)}
                tipoprecio={Number(tipoprecio)}
                enableCreate={false}
                findNoCombo={findNoCombo}              
                findStock={findStock}
                disableSelection={disableSelection}
                enableSelectionFinder={enableSelectionFinder}
                enableSelectionClick={enableSelectionClick}
                enableCheckboxSelection={enableCheckboxSelection}
                tipovista={tipovista}
              />
            </ArticulosState>
          </div>
        </div>
        <button
          className="modalCloseButton"
          onClick={() => setIsModalOpen(false)}
        >
          ❌
        </button>
      </Modal>
    </>
  );
};

export default ArticulosModal;
